import React from 'react';

import { Flex } from '@chakra-ui/react';
import { checkFeedbackInclusionEnabled } from 'utils/helpers/featureFlags';

import { MeshMavenAnalyze, MeshMavenAnalyzeAndDEI } from './MeshMavenAnalyze';
import MeshMavenRephrase from './MeshMavenRephrase';

const MeshMaven = () => (
  <Flex
    height="100%"
    flexDir="column"
    gap={2}
    overflow="auto"
    overflowX={checkFeedbackInclusionEnabled() ? 'hidden' : 'auto'}
  >
    <MeshMavenRephrase />
    {checkFeedbackInclusionEnabled() ? <MeshMavenAnalyzeAndDEI /> : <MeshMavenAnalyze />}
  </Flex>
);

export default MeshMaven;
